<!--
  FE-196 — `register_button_custom_color` recolours Register in the HEADER only.
  It is an inline style, so it outranks every stylesheet; applied in the drawer
  it made Register the one row in the list painted a different colour, which is
  exactly the standing-out the drawer must not do. The branding attribute is
  about the header's Register affordance, so it stays bound there and is left
  off the menu rows, which follow the drawer's own uniform styling.
-->
<ul [class.no-menu]="!isMenu">
  <li *ngFor="let item of links; let i = index">
    <a class="cursor-pointer"
       [style.color]="!isMenu && i > 0 ? (registerButtonColor$ | async)?.toString() : null"
      (click)="item.url === '#logout' ? logout($event) : handleClick($event, item.url)">
      {{ item.title }}
    </a>
  </li>
</ul>
